
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speech-to-text",
      function () {
        return require("private-next-pages/speech-to-text/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speech-to-text"])
      });
    }
  